export default "__VITE_ASSET__172947d1__"